/* Editorial interactions only: no cart, consent or analytics changes. */
(() => {
 const instances = new WeakMap();
 function init(scope = document) {
  scope.querySelectorAll('[data-journal]').forEach(root => {
   const nav = root.querySelector('[data-journal-categories]');
   if (!nav || nav.dataset.ready) return;
   nav.dataset.ready = 'true';
   const cards = [...root.querySelectorAll('[data-journal-category]')];
   const available = new Set(cards.flatMap(card => card.dataset.journalTags.split('|')));
   nav.querySelectorAll('[data-journal-filter]').forEach(button => {
    button.hidden = button.dataset.journalFilter !== 'all' && !available.has(button.dataset.journalFilter);
   });
   nav.hidden = !cards.length;
   nav.addEventListener('click', event => {
    const button = event.target.closest('[data-journal-filter]');
    if (!button) return;
    let count = 0;
    cards.forEach(card => {
     card.hidden = button.dataset.journalFilter !== 'all' && !card.dataset.journalTags.split('|').includes(button.dataset.journalFilter);
     if (!card.hidden) count++;
    });
    nav.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    root.querySelector('[data-journal-empty]').hidden = count > 0;
   });
  });
  scope.querySelectorAll('[data-native-article]').forEach(body => {
   const toc = body.closest('article').querySelector('[data-native-toc]');
   const headings = [...body.querySelectorAll('h2')];
   if (!toc || headings.length < 3 || !toc.hidden) return;
   headings.forEach((heading, index) => {
    if (!heading.id) {
     let id = `lecture-${index + 1}`;
     while (document.getElementById(id)) id += '-s';
     heading.id = id;
    }
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    toc.querySelector('nav').append(link);
   });
   toc.hidden = false;
  });
  scope.querySelectorAll('[data-editorial-hero]').forEach(root => {
   if (instances.has(root)) return;
   const slides = [...root.querySelectorAll('[data-slide]')];
   if (slides.length < 2) return;
   const controller = new AbortController(), signal = controller.signal;
   const buttons = [...root.querySelectorAll('[data-hero-index]')];
   const pause = root.querySelector('[data-hero-pause]'), content = root.querySelector('[data-hero-content]');
   const motion = matchMedia('(prefers-reduced-motion: reduce)');
   let current = 0, timer, idleTimer, userPaused = false, paused = motion.matches || Boolean(window.Shopify?.designMode), hovered = false, busy = false, start = null, resumeRequested = false, pointerPause = null, suppressClick = false;
   const prepare = async index => {
    const slide = slides[index], image = slide.querySelector('img');
    slide.querySelectorAll('source[data-srcset]').forEach(source => { source.srcset = source.dataset.srcset; delete source.dataset.srcset; });
    if (image.dataset.src) {
     image.srcset = image.dataset.srcset;
     image.src = image.dataset.src;
     delete image.dataset.src; delete image.dataset.srcset;
    }
    try { await image.decode(); } catch { /* Keep the last successful slide if an asset fails. */ }
    return image.complete && image.naturalWidth > 0;
   };
   const schedule = () => {
    clearTimeout(timer);
    if (!paused && !hovered && !document.hidden && (!root.contains(document.activeElement) || resumeRequested)) {
     timer = setTimeout(() => show((current + 1) % slides.length), 6000);
    }
   };
   const show = async index => {
    if (signal.aborted || busy || index === current) { schedule(); return; }
    busy = true;
    const ready = await prepare(index);
    if (signal.aborted) return;
    if (!ready) { busy = false; paused = true; updatePause(); return; }
    slides[current].classList.remove('is-current'); slides[current].setAttribute('aria-hidden', 'true');
    current = index;
    slides[current].classList.add('is-current'); slides[current].setAttribute('aria-hidden', 'false');
    content.replaceChildren(slides[current].querySelector('template').content.cloneNode(true));
    buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
    busy = false; schedule();
    if (!motion.matches && !navigator.connection?.saveData) prepare((current + 1) % slides.length);
   };
   const updatePause = () => {
    pause.textContent = paused ? 'Lecture' : 'Pause';
    pause.setAttribute('aria-label', paused ? 'Reprendre le diaporama' : 'Mettre le diaporama en pause');
   };
   const interact = index => { paused = userPaused || motion.matches || Boolean(window.Shopify?.designMode); resumeRequested = !paused; hovered = false; clearTimeout(timer); updatePause(); show(index); };
   root.querySelector('[data-hero-controls]').hidden = false;
   buttons.forEach((button, i) => button.addEventListener('click', () => interact(i), {signal}));
   pause.addEventListener('pointerdown', () => { pointerPause = !paused; }, {signal});
   pause.addEventListener('click', () => {
    userPaused = pointerPause ?? !paused; paused = userPaused || motion.matches || Boolean(window.Shopify?.designMode); pointerPause = null; resumeRequested = !paused; hovered = false; updatePause(); schedule();
   }, {signal});
   root.addEventListener('pointerdown', event => {
    suppressClick = false;
    if (event.pointerType === 'touch') start = {x:event.clientX, y:event.clientY};
   }, {signal});
   root.addEventListener('pointerup', event => {
    if (!start) return;
    const dx = event.clientX - start.x, dy = event.clientY - start.y; start = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) { suppressClick = true; interact((current + (dx < 0 ? 1 : -1) + slides.length) % slides.length); }
   }, {signal});
   root.addEventListener('click', event => { if (suppressClick) { suppressClick = false; event.preventDefault(); event.stopPropagation(); } }, {capture:true, signal});
   root.addEventListener('pointercancel', () => { start = null; }, {signal});
   root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; clearTimeout(timer); } }, {signal});
   root.addEventListener('pointerleave', () => { hovered = false; schedule(); }, {signal});
   root.addEventListener('focusin', () => { resumeRequested = false; paused = true; clearTimeout(timer); updatePause(); }, {signal});
   document.addEventListener('visibilitychange', schedule, {signal});
   motion.addEventListener('change', () => { paused = userPaused || motion.matches || Boolean(window.Shopify?.designMode); updatePause(); schedule(); }, {signal});
   root.closest('.shopify-section')?.addEventListener('shopify:block:select', event => {
    const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
    if (index >= 0) interact(index);
   }, {signal});
   const begin = () => {
    schedule();
    if (!motion.matches && !navigator.connection?.saveData) idleTimer = setTimeout(() => { if (!signal.aborted) prepare(1); }, 1500);
   };
   updatePause();
   if (document.readyState === 'complete') begin(); else window.addEventListener('load', begin, {once:true, signal});
   instances.set(root, () => { clearTimeout(timer); clearTimeout(idleTimer); controller.abort(); });
  });
 }
 init();
 document.addEventListener('shopify:section:load', event => init(event.target));
 document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-editorial-hero]').forEach(root => { instances.get(root)?.(); instances.delete(root); }));
})();
